// X&O 3×3 board. Pure presentational — takes the current cells + who
// can click and calls onCellClick(i). No game logic here; the Xo page
// owns turn state, winner detection, round progression.
//
// Marks come from the shared `<Mark>` SVG component so X and O render
// at matching stroke weight everywhere they appear in the game (not
// just on the board — also in player cards, VS cards, etc).
import Mark from './Mark';

export type Cell = 'x' | 'o' | null;

type Props = {
  cells: Cell[];                    // length 9, row-major
  canClick: boolean;                // true only on the local player's turn
  disabledCells?: boolean[];        // per-cell override (e.g. during splash)
  winLine?: number[] | null;        // indices of the winning 3 cells
  winner?: 'x' | 'o' | null;        // for the winning-line colour
  onCellClick: (i: number) => void;
};

export default function Board({
  cells, canClick, disabledCells, winLine, winner, onCellClick,
}: Props) {
  return (
    <div className="xo-board-wrap">
      <div className="xo-board">
        {cells.map((mark, i) => {
          const isWin = winLine?.includes(i);
          const classes = [
            'xo-cell',
            mark ? 'xo-cell-filled' : '',
            (!canClick || mark || disabledCells?.[i]) ? 'xo-cell-disabled' : '',
            isWin && winner === 'x' ? 'xo-win-x' : '',
            isWin && winner === 'o' ? 'xo-win-o' : '',
          ].filter(Boolean).join(' ');
          return (
            <div
              key={i}
              className={classes}
              onClick={() => {
                if (!canClick || mark || disabledCells?.[i]) return;
                onCellClick(i);
              }}
              role="button"
              aria-label={`Cell ${i + 1}${mark ? ` has ${mark.toUpperCase()}` : ''}`}
            >
              {mark && <Mark kind={mark} />}
            </div>
          );
        })}
      </div>
    </div>
  );
}
